<template>
  <b-button @click="$emit('click')" type="is-primary" :expanded="expanded">{{ $t('Reset') }}</b-button>
</template>

<script>
 export default {
   props: {
     expanded: {
       type: Boolean,
       default: true
     }
   }
 }
</script>
